import rawManifest from "../stable/latest.json";
import { parseReleaseManifest } from "./index";

export const stableReleaseManifest = parseReleaseManifest(rawManifest);
